export const PasswordValidatorFields = {
  length: 'length',
  upperCase: 'upperCase',
  lowerCase: 'lowerCase',
  number: 'number',
};

export const PasswordValidator = (password) => ({
  length: password.length >= 8,
  upperCase: /[A-Z]/.test(password),
  lowerCase: /[a-z]/.test(password),
  number: /[0-9]/.test(password),
});

const SignUpFormValidator = (form) => ({
  firstName: (firstName = '') => {
    if (!firstName.trim()) return 'First name cannot be empty';
  },
  lastName: (lastName = '') => {
    if (!lastName.trim()) return 'Last name cannot be empty';
  },
  email: (email = '') => {
    if (!email.trim()) return 'Email cannot be empty';
  },
  password: (password = '') => {
    const passwordValidator = PasswordValidator(password);

    if (!password.trim()) return 'Password cannot be empty';

    if (!passwordValidator.length)
      return 'Password must have length greater or equal 8 characters';

    if (!passwordValidator.lowerCase)
      return 'Password must have a lowercase letter';

    if (!passwordValidator.number) return 'Password must have a number';
  },
  passwordConfirmation: (passwordConfirmation = '') => {
    if (form.password !== passwordConfirmation) return 'Passwords do not match';
  },
});

export default SignUpFormValidator;
